import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import { update, list } from "../../actions";

export default () => {
  const moduleName = `users`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const [id, setId] = useState(``);
  const [firstName, setFirstName] = useState(``);
  const [lastName, setLastName] = useState(``);
  const [email, setEmail] = useState(``);
  const [mobile, setMobile] = useState(``);
  const [national, setNational] = useState(``);
  const [identy, setIdenty] = useState(``);
  const [status, setStatus] = useState(``);

  const handleClick = () => {
    dispatch(update(id, moduleName));
  };

  useEffect(() => {
    if (appReducer.auth_currents_list != undefined) {
      let row = appReducer.auth_currents_list.data;
      setId(row.id);
      setFirstName(row.first_name);
      setLastName(row.last_name);
      setEmail(row.email);
      setMobile(row.mobile);
      setNational(row.national);
      setStatus(row.state)
      setIdenty(row.identy);
    }
  }, [appReducer.auth_currents_list]);

  useEffect(() => {
    dispatch(list(`auth/currents`));
  }, []);

  return (
    <Template.Form>

      <input defaultValue={status} name="state" type="hidden" id="state" />

      <Template.Input
        mb={3}
        value={firstName}
        label="نام"
        name="first_name"
        type="text"
      />

      <Template.Input
        mb={3}
        value={lastName}
        label="نام خانوادگی"
        name="last_name"
        type="text"
      />

      <Template.Input
        mb={3}
        value={national}
        label="کدملی"
        className="ltr"
        name="national"
        type="text"
      />

      <Template.Input
        mb={3}
        value={identy}
        className="ltr"
        label="شماره شناسنامه"
        name="identy"
        type="text"
      />

      <Template.Input
        mb={3}
        required
        value={mobile}
        label="موبایل"
        name="mobile"
        className="ltr"
        type="text"
      />
      <Template.Input
        mb={3}
        value={email}
        label="ایمیل"
        name="email"
        className="ltr"
        type="email"
      />
      <Template.Input
        mb={3}
        className="ltr"
        label="رمزعبور"
        name="password"
        type="password"
      />
      <Template.Button label="ذخیره" onClick={handleClick} />
    </Template.Form>
  );
};
